/**
 * Sanitizes and validates URLs for use in the link editor
 * Prevents XSS and ensures consistent URL handling
 */
export function sanitizeUrl(url: string): string {
  try {
    const trimmed = url.trim();
    if (!trimmed) return '';

    // Allow safe protocols
    if (/^(https?:|mailto:|tel:|sms:)/i.test(trimmed)) {
      return trimmed;
    }

    // Convert bare domains to https
    if (/^[\w.-]+\.[a-z]{2,}/i.test(trimmed)) {
      return `https://${trimmed}`;
    }

    return '';
  } catch {
    return '';
  }
}

/**
 * Validates if a URL is acceptable for linking
 */
export function validateUrl(url: string): boolean {
  return !!sanitizeUrl(url);
}
